/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

import { fetchShipmentAttachments, type ShipmentAttachment } from "pages/shipper/ShipmentDetails/v2/attachmentsApi";

import { shipmentQueryKeys } from "./shipmentQueryKeys";

export const useGetAttachments = (
  shipmentId: string,
  options: UseQueryOptions<ShipmentAttachment[]> = {},
) =>
  useQuery({
    queryKey: shipmentQueryKeys.shipmentAttachments(shipmentId),
    queryFn: () => fetchShipmentAttachments(shipmentId),
    ...options,
    enabled: Boolean(shipmentId) && (options.enabled ?? true),
  });
